import React, { useState } from "react";

export interface AboutCardProps {
  title: string;
  description: string;
  iconSrc: string;
  circleSrc: string;
}

export function AboutCard({
  title,
  description,
  iconSrc,
  circleSrc,
}: AboutCardProps): React.ReactElement {
  const [circleError, setCircleError] = useState(false);
  const [iconError, setIconError] = useState(false);

  return (
    <article className="h-full bg-[#f8f8f8] rounded-2xl p-8 flex flex-col items-center text-center min-h-[384px] border-t-4 border-transparent shadow-sm transition-all duration-200 ease-out hover:shadow-lg hover:border-navy hover:-translate-y-1">
      <div className="relative mb-4 flex justify-center w-[90px] h-[90px] shrink-0">
        {!circleError ? (
          <img
            src={circleSrc}
            alt=""
            className="w-[90px] h-[90px] object-contain"
            aria-hidden
            onError={() => setCircleError(true)}
          />
        ) : (
          <div
            className="w-[90px] h-[90px] rounded-full bg-navy shrink-0"
            aria-hidden
          />
        )}
        {!iconError ? (
          <img
            src={iconSrc}
            alt=""
            className="absolute w-12 h-12 object-contain top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            aria-hidden
            onError={() => setIconError(true)}
          />
        ) : (
          <div
            className="absolute w-10 h-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold/30"
            aria-hidden
          />
        )}
      </div>
      <h3 className="text-black text-2xl font-semibold tracking-tight mb-2 shrink-0">
        {title}
      </h3>
      <p className="text-gray-body text-lg font-medium leading-relaxed flex-1 min-h-0">
        {description}
      </p>
    </article>
  );
}

export default AboutCard;
